import React from "react";
import PropTypes from "prop-types";

export default class AnnouncementBox extends React.Component {
    static defaultProps = {
        delay: 1000,
    };

    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        icon: PropTypes.string,
        ctaText: PropTypes.string,
        ctaUrl: PropTypes.string,
        onClose: PropTypes.func,
        isWarning: PropTypes.bool,
    };

    handleClose() {
		this.setState({open: false});
		if (this.props.onClose) this.props.onClose();
	}

	handleCTA() {
        if (this.props.onClick) this.props.onClick();
        if (this.props.ctaUrl) {
			window.open(this.props.ctaUrl, "_blank", "noopener,noreferrer");
		}
	}

	constructor(props) {
		super(props);

        this.state = {
            open: true,
        };
	}
	render() {
	
		// Handle controlled/uncontrolled state
		const open = this.state.open;

		if (!open) return null;

		return (
            <div className={"top-line-announcement " + (this.props.isWarning ? "top-line-warning" : "top-line-normal")}>
                <div className="top-line-announcement-content">
                    <div className="top-line-announcement-text">
                        <span className="top-line-announcement-title">{this.props.icon ? <span className={"fa fa-" + this.props.icon} style={{"paddingRight": ".5em"}}></span> : null}{" "}{this.props.title}</span>{" "}
                        <span className="top-line-announcement-body" dangerouslySetInnerHTML={{__html: this.props.message}}></span>
                        { this.props.ctaText && this.props.ctaUrl ? (
                            <button className="top-line-announcement-cta" onClick={() => this.handleCTA()}>
                                {this.props.ctaText}{" "}
                                <span className="right-arrow">
                                    <i className="fa fa-arrow-right"></i>
                                </span>
                            </button>
                        ) : null }
                    </div>
                    <div className="top-line-announcement-close" onClick={() => {
                        this.setState({open: false});
                        if (this.props.onClose) this.props.onClose();
                    }}><i className="fa fa-times"></i></div>
                </div>
            </div>
		);
	}
}
